import Frame from './Frame/Frame';
import Pane from './Pane/Pane';
import Shell from './Shell/Shell';

const TileKit = {
  Shell,
  Frame,
  Pane
};

export default TileKit;
